// Modal.tsx
import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function Modal({ isOpen, onClose, children }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '16px', // prevent modal from touching screen edges
      }}
    >
      <div className='custom_modal'>
        {/* Close Button */}
        {/* <div style={{ textAlign: 'right', padding: '12px 16px 0' }}>
          
        </div> */}

        {/* Scrollable content */}
        <div className=''>
          {children}
        </div>
      </div>
    </div>
  );
}

